import React, { useEffect, useState } from "react";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import SelectField from "../../forms/select-field";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import { url } from "../../../redux/config";
import LeftArrowIcon from "../../../assets/icons/ABHA-icons/left-arrow-icon";
import AddButton from "../../buttons/button";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import InfoIcon from "../../../assets/icons/ABHA-icons/info-icon";
import CautionIcon2 from "../../../assets/icons/ABHA-icons/caution-icon2";
import HybridSelectField from "../../forms/select-input-field";

function Address({
  txnId,
  adhaarAccessToken,
  setTxnId,
  setStatus,
  setPosition,
  closeModal,
  setNewABHAaddress,
}) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    abhaAddress: "",
    consent: "",
  };

  const validationSchema = Yup.object().shape({
    abhaAddress: Yup.string().required("Select ABHA Address"),
    consent: Yup.boolean()
      .oneOf([true], "Please select the condition")
      .required("Please select the condition"),
    captcha: Yup.string(),
  });

  const mapListToOptions = (data) => {
    return (
      data?.map((item) => ({
        label: item,
        value: item,
      })) || []
    );
  };

  const getABHAaddress = async () => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/abha-create-enrollment-via-aadhaar-fetch-address-sugession`,
        {
          txnId: txnId,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      successToast("got list");
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      setList(
        mapListToOptions(response?.data?.data?.abdmResponse?.abhaAddressList)
      );
    } catch (error) {
      errorToast(error.response?.data || error.message);
      // Optionally handle error further
    }
  };

  useEffect(() => {
    getABHAaddress();
    // eslint-disable-next-line
  }, []);

  // Dummy onSubmit for Formik demo ― replace with your real handler
  const handleSubmit = (values) => {
    // Do something with selected address (values.abhaAddress)
    successToast(`Submitted ABHA Address: ${values.abhaAddress}`);
  };

  const updateABHAaddress = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-create-enrollment-via-aadhaar-update-new-address`,
        {
          txnId: txnId,
          abhaAddress: values.abhaAddress,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response);
      successToast("ABHA Address is Updated");
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      // setmessage(response?.data?.data?.abdmResponse?.message);
      console.log(
        "new address",
        response?.data?.data?.abdmResponse?.preferredAbhaAddress
      );
      setNewABHAaddress(
        response?.data?.data?.abdmResponse?.preferredAbhaAddress
      );
      setStatus("Confirmation");
      setPosition(4);

      setLoading(false);
      //   setPopUp(true);

      return response.data;
    } catch (error) {
      errorToast(error?.data?.error?.message || error.message);
      console.error(
        "Error verifying OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={updateABHAaddress}
    >
      {({
        values,
        setFieldValue,
        errors,
        touched,
        handleSubmit,
        handleChange,
      }) => (
        <Form className="flex flex-col h-full">
          <div className="flex-1 flex flex-col gap-6 mt-6">
            <div
              onClick={() => {
                setStatus("OTP Verification");
                setPosition(1);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              className="flex flex-row gap-2 items-center cursor-pointer "
            >
              <LeftArrowIcon />
              <label
                className={`
                cursor-pointer text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap`}
              >
                Back
              </label>
            </div>
            <label
              className={`
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
            >
              Create ABHA Address
            </label>
            <div>
              <div className="w-full">
                <HybridSelectField
                  label="ABHA Address"
                  labelClass="text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]"
                  isContainer={true}
                  containerClass="w-full" // This makes the container full width
                  parentClass="w-full flex flex-col gap-2" // This ensures the field takes full width
                  id="abhaAddress"
                  placeholder="john.doe"
                  suffix="@abdm" // Shows @abdm on the right side
                  options={list}
                  name="abhaAddress"
                  isSearchable={true}
                  isRequired={true}
                  allowCustomInput={true}
                  inputBorder="border border-[var(--input-border)]"
                  errorBorder="border border-[var(--input-error-border)]"
                  handleSelected={(option) => {
                    console.log("Selected:", option);
                  }}
                />
                {/* <SelectField
                  label={"Select ABHA Address"}
                  labelClass={
                    "text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full"
                  }
                  general_color="true"
                  borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                  isContainer={true}
                  containerClass="w-full flex flex-col gap-2"
                  parentClass="w-full flex flex-col gap-2"
                  // Set isDisabled as needed
                  id="abhaAddress"
                  placeholder="Select ABHA Address"
                  options={list}
                  name="abhaAddress"
                  isSearchable={true}
                  isRequired={true}
                  value={values.abhaAddress}
                  onChange={(option) =>
                    setFieldValue("abhaAddress", option.value)
                  }
                  // Optionally display errors:
                  error={touched.abhaAddress && errors.abhaAddress}
                /> */}
              </div>
              <label
                className={`text-[var(--abha-nav-fg)] leading-[23px]
                             text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                Your ABHA address will be used to access health records and
                services
              </label>
            </div>
            <div className="w-full border flex flex-col bg-[var(--abha-caution-bg)] border-[var(--primary)] rounded-lg  gap-[10px] p-5">
              <div className=" flex flex-row gap-[10px]">
                <InfoIcon />
                <ul className="flex flex-col gap-2">
                  <label
                    className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap `}
                  >
                    ABHA Address Benefits
                  </label>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Easy to remember health ID for accessing services
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Secure storage and sharing of health records
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Quick login to ABDM-enabled healthcare apps
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    • Control over who can access your health data
                  </li>
                </ul>
              </div>
            </div>
            <div className="p-[10px]  flex gap-3 rounded-lg">
              {/* <input type="checkbox" className="mb-auto mt-2" /> */}
              <Field type="checkbox" name="consent" className="mb-auto mt-1" />
              <label
                className={`text-[var(--abha-nav-fg)] leading-[23px]
                             text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                I agree to share my Aadhaar details for ABHA creation as per
                ABDM guidelines. This information will be used solely for the
                purpose of creating your ABHA number and will be handled in
                accordance with data protection regulations.
              </label>
            </div>
            <div className="border bg-[var(--abha-card2-fg)] border-[var(--success-color)] rounded-lg flex flex-row gap-[10px] p-[10px]">
              <CautionIcon2 />
              <label
                className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                Your Aadhaar number will be securely encrypted before
                submission. We follow strict security protocols to protect your
                personal information.
              </label>
            </div>

            <div
              style={{
                bottom: "0",
              }}
              className="flex flex-row gap-3 justify-end  sticky bg-white py-4 mt-auto "
            >
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                onclkFn={() => closeModal()}
                text={<span>Cancel</span>}
                className="
                flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
                 cursor-pointer
                text-[var(--primary-button-bg-color)]
                border border-[var(--primary-button-bg-color)]
                text-[length:var(--primary-button-create-fs)]
                font-[var(--primary-button-font-weight)]
                "
                type="button"
              />
              <AddButton
                prefixIcon={false}
                // loading={loading}
                onclkFn={() => {
                  setStatus("Confirmation");
                  setPosition(4);
                }}
                text={<span>skip</span>}
                className="
                flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
                bg-[var(--primary-button-bg-color)] cursor-pointer
                text-[var(--primary-button-fg-color)]
                border border-[var(--primary-button-bg-color)]
                hover:bg-[var(--primary-button-hover-color)]
                text-[length:var(--primary-button-create-fs)]
                font-[var(--primary-button-font-weight)]
                "
                type="submit"
              />
              <AddButton
                prefixIcon={false}
                loading={loading}
                onclkFn={() => handleShowErrorToast(errors)}
                text={<span>Next</span>}
                className="
                flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
                bg-[var(--primary-button-bg-color)] cursor-pointer
                text-[var(--primary-button-fg-color)]
                border border-[var(--primary-button-bg-color)]
                hover:bg-[var(--primary-button-hover-color)]
                text-[length:var(--primary-button-create-fs)]
                font-[var(--primary-button-font-weight)]
                "
                type="submit"
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Address;
